@if (canArchive) {
  <div class="project-archive-container">
    <div class="section">
      <h3 class="section-title">Project archive</h3>
      <p class="subtitle">
        Build a downloadable zip of this project's daily reports, change orders, pay apps and documents.
      </p>

      @if (loading) {
        <div class="loading-container">
          <mat-spinner diameter="24"></mat-spinner>
        </div>
      }

      @if (!loading) {
        @if (isBuilding) {
          <div class="in-progress-panel">
            @if (hasProgress) {
              <div class="in-progress-text in-progress-text--determinate">
                <span class="in-progress-title">Building archive — {{ latest.progress.section }}…</span>
                <mat-progress-bar mode="determinate" [value]="progressPercent" color="primary" class="progress-bar"></mat-progress-bar>
                <span class="hint">{{ progressSummary }}</span>
                <span class="hint">We'll email you a download link when it's ready — you can leave this page.</span>
              </div>
            } @else {
              <mat-spinner diameter="24" mode="indeterminate" strokeWidth="3" color="primary"></mat-spinner>
              <div class="in-progress-text">
                <span class="in-progress-title">Building archive…</span>
                <span class="hint">We'll email you a download link when it's ready — you can leave this page.</span>
                @if (buildElapsed) {
                  <span class="hint">Started {{ buildElapsed }}</span>
                }
              </div>
            }
          </div>
        } @else if (latest?.status === 'ready') {
          <div class="archive-state">
            <div class="actions-row">
              <button
                mat-flat-button
                color="primary"
                type="button"
                [disabled]="downloading"
                (click)="downloadArchive()"
                class="archive-btn"
                >
                Download archive
              </button>
              @if (isWithinRebuildCooldown) {
                <span class="hint rebuild-hint">Rebuild available after 24h</span>
              } @else {
                <button mat-button type="button" color="primary" (click)="buildArchive()" class="rebuild-link">
                  Rebuild
                </button>
              }
            </div>
            <div class="metadata">
              <span>{{ formatBytes(latest.file_size) }}</span>
              <span class="dot">·</span>
              <span>Built {{ latest.created_at | dateFormat: 'very-long' }}</span>
              <span class="dot">·</span>
              <span>Link available until {{ latest.expires_at | dateFormat: 'very-long' }}</span>
            </div>
            @if (countsEntries.length > 0) {
              <div class="counts-summary">
                @for (c of countsEntries; track c.section; let last = $last) {
                  <span>{{ c.section }}: {{ c.included }}{{ c.failed > 0 ? ' (' + c.failed + ' failed)' : '' }}{{ c.configIssues > 0 ? ' (' + c.configIssues + ' config issue' + (c.configIssues > 1 ? 's' : '') + ')' : '' }}</span>
                  @if (!last) {
                    <span class="dot">·</span>
                  }
                }
              </div>
            }
          </div>
        } @else {
          <div class="archive-state">
            <button mat-flat-button color="primary" type="button" (click)="buildArchive()" class="archive-btn">
              {{ buildButtonLabel }}
            </button>
            @if (latest?.status === 'failed') {
              <span class="error-hint" [title]="latest.error">Archive build failed — please try again.</span>
            }
            @if (latest?.status === 'expired') {
              <span class="hint">The previous archive file has expired.</span>
            }
          </div>
        }
      }
    </div>
  </div>
}
